import { PersonDto } from '../api/person/models/PersonDto'
import { WorkedAtDto } from '../api/person/models/WorkedAtDto'

// Function overloads
export function getProfilePicUrl(
    person: PersonDto,
    fallBackToDefault: true,
): string
export function getProfilePicUrl(
    person: PersonDto,
    fallBackToDefault?: false,
): string | undefined

// Function implementation
export function getProfilePicUrl(
    person: PersonDto,
    fallBackToDefault: boolean = false,
): string | undefined {
    if (person.linkedInProfilePicUrl) {
        return person.linkedInProfilePicUrl
    } else if (fallBackToDefault) {
        return '/no-profile-pic.svg'
    } else {
        return undefined
    }
}

export function getCountryFlag(countryName: string): string {
    if (!countryName) return ''

    // All ISO 3166-1 alpha-2 country codes
    const regionCodes = new Intl.DisplayNames(['en'], { type: 'region' })

    for (let i = 0; i < 26 * 26; i++) {
        const code =
            String.fromCharCode(65 + Math.floor(i / 26)) +
            String.fromCharCode(65 + (i % 26))

        if (regionCodes.of(code)?.toLowerCase() === countryName.toLowerCase()) {
            return code
                .toUpperCase()
                .replace(/./g, (char) =>
                    String.fromCodePoint(0x1f1e6 + char.charCodeAt(0) - 65),
                )
        }
    }

    return ''
}

export function formatText(text: string): string {
    if (!text) return ''

    let formatted = text

    if (formatted.includes('  ')) {
        formatted = formatted.replace(/\s{2,}/g, '\n\n')
    }

    formatted = formatted.replace(/\s*•/g, '\n•')

    return formatted
}

export function getSortedWorkedAts(jobs: WorkedAtDto[]): WorkedAtDto[] {
    return [...jobs].sort((a, b) => {
        const aIsOngoing = !a.endDate
        const bIsOngoing = !b.endDate

        // Ongoing jobs come first
        if (aIsOngoing && !bIsOngoing) return -1
        if (!aIsOngoing && bIsOngoing) return 1

        // If both are ongoing or both are finished, sort by start date (desc)
        const dateA = a.startDate ? new Date(a.startDate).getTime() : 0
        const dateB = b.startDate ? new Date(b.startDate).getTime() : 0
        return dateB - dateA
    })
}

export function formatPersonName(parts: {
    firstName?: string
    middleName?: string | null
    lastName?: string | null
}): string {
    const tokens = [
        parts.firstName,
        parts.middleName ?? undefined,
        parts.lastName ?? undefined,
    ]
        .map((s) => (typeof s === 'string' ? s.trim() : ''))
        .filter((s) => s.length > 0)
    return tokens.join(' ')
}
